<div
  class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
  style="min-height: 200px; background-size: cover; background-position: center top"
>
  <span class="mask bg-gradient-primary opacity-8"></span>
  <div class="container-fluid d-flex align-items-center">
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <h1 class="display-2 text-white">Configurações de Cashback</h1>
        <p class="text-white mt-0 mb-5">
          Defina o percentual de cashback e o limite de compra da sua loja.
        </p>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt--7">
  <div class="row justify-content-center">
    <div class="col-xl-8 col-lg-10">
      <div class="card bg-secondary shadow">
        <div class="card-header bg-white border-0">
          <div class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">Regras de Cashback</h3>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div *ngIf="!loaded" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Carregando...</span>
            </div>
          </div>

          <form *ngIf="loaded" [formGroup]="form" (ngSubmit)="onSubmit()">
            <h6 class="heading-small text-muted mb-4">Cashback da loja</h6>
            <div class="pl-lg-4">
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <label class="form-control-label" for="cashbackPercentual">
                      Percentual de cashback (%)
                    </label>
                    <input
                      id="cashbackPercentual"
                      type="number"
                      step="0.1"
                      min="0.1"
                      max="100"
                      class="form-control form-control-alternative"
                      formControlName="cashbackPercentual"
                      placeholder="Ex: 5"
                    />
                    <small class="text-muted">
                      Percentual que o cliente receberá de volta em cada compra aprovada.
                    </small>
                    <div
                      *ngIf="form.get('cashbackPercentual')?.invalid && form.get('cashbackPercentual')?.touched"
                      class="text-danger mt-1"
                      style="font-size: 0.85rem"
                    >
                      Informe um valor entre 0,1% e 100%.
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label class="form-control-label" for="limiteCompra">
                      Limite por compra (R$)
                    </label>
                    <input
                      id="limiteCompra"
                      type="number"
                      step="1"
                      min="1"
                      class="form-control form-control-alternative"
                      formControlName="limiteCompra"
                      placeholder="Ex: 200"
                    />
                    <small class="text-muted">
                      Valor máximo que o cliente pode informar por compra.
                    </small>
                    <div
                      *ngIf="form.get('limiteCompra')?.invalid && form.get('limiteCompra')?.touched"
                      class="text-danger mt-1"
                      style="font-size: 0.85rem"
                    >
                      Informe um valor mínimo de R$ 1,00.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr class="my-4" />

            <div class="alert alert-info" role="alert">
              <span class="alert-icon"><i class="ni ni-bell-55"></i></span>
              <span class="alert-text">
                <strong>Como funciona:</strong>
                O cashback gerado só pode ser utilizado na sua loja e tem validade de <strong>40 dias</strong>.
                Após esse período, o saldo expira automaticamente.
              </span>
            </div>

            <button
              type="submit"
              class="btn btn-info"
              [disabled]="saving || form.invalid"
            >
              <span *ngIf="saving" class="spinner-border spinner-border-sm mr-2" role="status"></span>
              {{ saving ? 'Salvando...' : 'Salvar configurações' }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
